module.exports = __webpack_public_path__ + "static/media/snap_zoomed2.8d15a2eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/snap/snap_zoomed2.png
// module id = 42
// module chunks = 0